import { ICancelRequest, ICancelRequestInterceptor } from 'interfaces/request.interfaces';

class CancelRequestService {
  private requests: ICancelRequest[] = [];
  private interceptors: ICancelRequestInterceptor[] = [];

  public addRequest(request: ICancelRequest): void {
    this.requests.push(request);

    for (const interceptor of this.interceptors) {
      interceptor.callback(request.id);
    }
  }

  public removeRequest(requestId: string): void {
    this.requests = this.requests.filter(item => item.id !== requestId);
  }

  public cancelRequests(requestIds: string[]): void {
    const newRequests: ICancelRequest[] = [];

    for (const request of this.requests) {
      if (requestIds.includes(request.id)) {
        request.cancel();
      } else {
        newRequests.push(request);
      }
    }

    this.requests = newRequests;
  }

  public cancelRouteRequests(path: string): void {
    const newRequests: ICancelRequest[] = [];

    for (const request of this.requests) {
      if (request.path === path) {
        request.cancel();
      } else {
        newRequests.push(request);
      }
    }

    this.requests = newRequests;
  }

  public addInterceptor(interceptor: ICancelRequestInterceptor): void {
    this.interceptors.push(interceptor);
  }

  public removeInterceptor(name: string): void {
    this.interceptors = this.interceptors.filter(item => item.name !== name);
  }
}

export default new CancelRequestService();
